<template>
  <div class="login">
    <button @click="googleLogin">Googleアカウントでログイン</button>
    <router-link to="/" tag="button">メモへ戻る</router-link>
  </div>
</template>

<script>
import auth from "../utils/auth";
export default {
  methods: {
    googleLogin() {
      auth.googleLogin();
    }
  }
};
</script>
